@import '~style-sheet-helpers/core.less';

.body {
  display: flex;
}

.details-section {
  display: flex;
  flex-wrap: wrap;

  min-width: 427px;
  width: 427px;
  padding: 16px;
  height: 100%;

  > div {
    min-width: 50%;
    > dd > :not(:first-child) {
      margin-left: 8px;
    }
  }
}

.tracking-link-icon {
  height: 12px;
  padding-left: 2px;
}
